import { useCallback, useEffect, useState } from 'react';
import { computeBatchState } from '../lib/selfPhoneBatches';
import {
  SELF_PHONE_TOTAL_UNITS,
  type PhoneInventory,
} from '../lib/selfPhoneProduct';

const DEFAULT_BATCH = computeBatchState(0, SELF_PHONE_TOTAL_UNITS);

const DEFAULT: PhoneInventory = {
  total: SELF_PHONE_TOTAL_UNITS,
  sold: 0,
  remaining: SELF_PHONE_TOTAL_UNITS,
  soldOut: false,
  ...DEFAULT_BATCH,
};

export function usePhoneInventory(pollMs = 8000) {
  const [inventory, setInventory] = useState<PhoneInventory>(DEFAULT);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch('/.netlify/functions/phone-inventory');
      if (!res.ok) {
        throw new Error('Could not load availability');
      }
      const data = (await res.json()) as PhoneInventory;
      setInventory(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not load availability');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = window.setInterval(refresh, pollMs);
    return () => window.clearInterval(id);
  }, [pollMs, refresh]);

  return { inventory, loading, error, refresh };
}
